import { on, select, selectAll, trigger, getModuleOptions } from 'modules/dom'

const SIGN_IN_TRIGGER_SELECTOR = '.js-modal-account'
const MODULE_NAME = 'content-block'

export default (el) => {
  const defaultOptions = {
    required_logged_in: false
  }
  const options = getModuleOptions(MODULE_NAME, el)

  /**
   * Handle all readyassessments links
   */
  const handleAllLinks = () => {
    const allLinks = selectAll('a', el);
    if (allLinks.length) {
      allLinks.map((link) => {
        const linkHref = link.getAttribute('href');
        if (linkHref.includes('econedlink.org/readyassessments') === true) {
          link.setAttribute('href', '?oac_checking');
        }
        if (linkHref.includes('readyassessments.econedlink.org') === true || linkHref.includes('ceestag.stg1.getmagicbox.com') === true) {
          link.setAttribute('href', '?oac_checking&redirect_url=' + linkHref);
        }
      });
    }
  };

  /**
   * Disable all links
   */
  const disableAllLinks = () => {
    const allLinks = selectAll('a', el)
    if (allLinks.length) {
      allLinks.map((link) => {
        const newSpan = document.createElement('span')
        newSpan.innerHTML = link.innerHTML
        link.parentNode.replaceChild(newSpan, link)
      })
    }
  }
  /**
   * Show modal login
   */
  const showLoginModal = () => {
    on('click', (e) => {
      e.preventDefault()
      const signInButton = select(SIGN_IN_TRIGGER_SELECTOR)
      if (signInButton) {
        trigger('click', signInButton)
      }
    }, el)
  }

  if (options.required_logged_in) {
    disableAllLinks()
    showLoginModal()
  }

  handleAllLinks()
}
